import { makeStyles, Theme, Typography } from "@material-ui/core";

const useStyles = makeStyles<Theme>((theme: Theme) => ({
    root: {
        color: theme.palette.error.main
    }
}
));

export const ErrorLabel: React.FC = ({children, ...props}) => {
    const classes = useStyles();

    return (
        <Typography variant="body1" classes={classes}>{children}</Typography>
    )
}
